import React, { useMemo } from "react";
import clsx from "clsx";
import { useDispatch } from "react-redux";

import IcnNotification from "@assets/icons/rounded/notifications.svg";
import IcnNotificationFill from "@assets/icons/rounded/notifications-fill.svg";
import IcnDelete from "@assets/icons/rounded/delete.svg";
import { IconComponent } from "@app/core";
import { authReducer } from "@app/redux/reducers/auth";
import { useAppSelector } from "@app/redux/store";
import { authThunks } from "@app/redux/thunks/auth.thunk";
import { DataWarehouseProductDTO } from "@app/bf-api";

import { IOutFeaturedDealDTO } from "../new-deal-card";
import styles from "./deal-like.module.scss";

export type DealLikeProps = {
  deal: DataWarehouseProductDTO | IOutFeaturedDealDTO;
  removeIcon?: boolean;
};

const component = ({ deal, removeIcon }: DealLikeProps) => {
  const { user } = useAppSelector(state => state.auth);
  const likedEans = useAppSelector(state => state?.auth.likedEans ?? []);
  const dispatch = useDispatch();

  const isLiked = useMemo(() => likedEans.find(ean => ean === deal.ean), [likedEans, deal.ean]);

  const handleLikeClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    if (!deal.ean) return;

    if (!user) {
      dispatch(authReducer.setEanToLike(deal.ean));
      return;
    }

    if (isLiked) {
      dispatch(authThunks.removeLikedDeal(deal.ean));

      return;
    }

    dispatch(authThunks.addLikedDeal(deal.ean));
  };

  return (
    <button
      type="button"
      data-cy="deal-like"
      data-ean={deal.ean}
      className={clsx(styles.root, isLiked && styles.isLiked, removeIcon && styles.removeIcon)}
      onClick={handleLikeClick}
    >
      <IconComponent icon={isLiked ? (removeIcon ? IcnDelete : IcnNotificationFill) : IcnNotification} size="24px" />
    </button>
  );
};

const DealLike = React.memo(component);

export { DealLike };
